import { createDeviceType, fetchDeviceTypes } from '@/features/device-types/api/deviceTypes';
import type { CreateDeviceTypeInput } from '@/features/device-types/types/deviceTypes';
import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from '@tanstack/react-query';

export const deviceTypeKeys = {
  all: ['device-types'] as const,
  list: () => [...deviceTypeKeys.all, 'list'] as const,
};

export function deviceTypesQuery() {
  return queryOptions({
    queryKey: deviceTypeKeys.list(),
    queryFn: ({ signal }) => fetchDeviceTypes({ signal }),
  });
}

export function useDeviceTypes() {
  return useQuery(deviceTypesQuery());
}

export function useSuspenseDeviceTypes() {
  return useSuspenseQuery(deviceTypesQuery());
}

export function useCreateDeviceType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateDeviceTypeInput) => createDeviceType(input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: deviceTypeKeys.all }),
  });
}
